import dayjs, { Dayjs } from "dayjs";
import { ApiClientProps } from "hooks/useApi";


export interface GeneratePayload {
    partnerVenueIds: string[];
    from: string | Date | Dayjs;
    to: string | Date | Dayjs;
    accessToken: string | undefined;
    apiClient: ApiClientProps;
}


export interface GenerateReservationListReportResponse {
    hasErrors: any;
    message: string;
    resource: {
        requestId: string;
        message: string;
    }

}

export interface ApiErr {
    hasErrors: true;
    status?: number;
    message?: string | null;
    detail?: string | null
}

function normalizeRange(from: string | Date | Dayjs, to: string | Date | Dayjs) {
    const start = dayjs(from).startOf("day");
    const end = dayjs(to).endOf("day");
    if (!start.isValid() || !end.isValid()) throw new Error("Invalid date range.");
    return { start, end, fromDate: start.toISOString(), toDate: end.toISOString() };
}

function requireAuthAndIds(accessToken?: string, ids?: string[]) {
    if (!accessToken) throw new Error("No accessToken provided.");
    if (!ids?.length) throw new Error("At least one partnerVenueId is required.");
}

export async function generateReservationListReport({
  partnerVenueIds,
  from,
  to,
  accessToken,
  apiClient,
}: GeneratePayload): Promise<GenerateReservationListReportResponse> {
    requireAuthAndIds(accessToken, partnerVenueIds);
    const { start, end } = normalizeRange(from, to);
    const spanDays = end.diff(start, "day") + 1; // inclusive
    if (spanDays > 15) {
        const message = `Date range exceeds 15 days (inclusive): ${spanDays} days. Please adjust your selection.`;
        const err: ApiErr = { hasErrors: true, status: 400, detail: message };
        throw Object.assign(new Error(message), err);
    }
    const body = JSON.stringify({
      fromDate: from,
      toDate: to,
      partnerVenueIds: partnerVenueIds.map(String),
    });
    const response = await apiClient.post({
      path: "/middleware-admin/partners/report/generate/reservation/list",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body,
    });
    return response as GenerateReservationListReportResponse;
}


